import React, { useEffect, useState } from 'react';


import '../../styles/pacientesPendientes.css'

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName, getUnidadHospitalariaValue } from '../../objects/unidadHospitalaria';

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';
//Componente que muestra al usuario que se esta procesando la información del servicio
import Loader from './loader';
//Componente que muestra la información de un paciente pendiente de alta medica
import PacientePendienteAlta from './pacienteCard';
//Componente que indica al usuario que no se obtuvo información con sus parámetros de búsqueda
import SinResultados from './sinResultados';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { compararInformación, descrifrar, getDateString, quitarAcentos, quitarCaracteresEspeciales } from '../../utils/functions';

/**
 * Componente que contiene el listado de pacientes pendientes de salida de quirófano
 * @param {Object} param0 Recibe la información de sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const PacientesPendientes = ({nomHospital,userLevel,uhList,name,isMostrarPacientes,setTotalQuirofano,setTotalRecuperacion,
    isLoader,pacientesList}) => {
    
    //Estado que indica la cantidad de pacientes con disponibles en el sistema
    const [cantidadPacientes,setCantidadPacientes] = useState(0)
    //Estado que indica si se hay pacientes que mostrar
    const [hayResultados, setHayResultados] = useState(false)
    //Estado que indica que se esta solicitando información al servicio
    //const [isLoader,setIsLoader] = useState(false)
    //Estado que indica si el estado anterior del paciente es recuperación
    const [isRecuperacionOrigen,setIsRecuperacionOrigen] = useState(false)
    //Estado que almacena la lista de contactos extras del paciente
    const [pacienteContactos,setPacienteContactos]=useState([])
    //Estado que indica si el usuario se encuentra en caso especial
    const [pacienteIsEspecial,setPacienteIsEspecial]=useState(false)
    //Estado que indica si el usuario se encuentra en sala de recuperación
    const [pacienteIsRecuperacion,setPacienteIsRecuperacion]=useState(false)
    //Estado que indica el paciente que ha sido seleccionado por el usuario
    const [pacienteSeleccionado,setPacienteSeleccionado] = useState(null)
    //Estado que indica la unidad hospitalaria a la que pertenece el paciente seleccionado por el usuario
    const [pacienteUnidadHospitalariaName,setPacienteUnidadHospitalariaName] = useState("")
    //Estado que indica si es posible para el usuario visualizar el teléfono del paciente
    const [pacienteTelefonoIsVisible,setPacienteTelefonoIsVisible]=useState(false)
    //Estado que indica si el paciente cuenta con contactos extras para notificación
    const [pacienteTieneContactos,setPacienteTieneContactos]=useState(false)
    //Estado que almacen el nombre de la unidad hospitalaria del paciente seleccionado
    const [pacienteUH,setPacienteUH]=useState("")
    //Estado que almacena los resultados de la búsqueda de pacientes según el parámetros requerido por el usuario
    const [pacientesAmostrarList,setPacientesAmostrarList] = useState([])
    //Estado que almacena los pacientes obtenidos desde la base de datos en una lista
    //const [pacientesList,setPacientesList] = useState([])
    //Estado que indica si se muestra la opción para limpiar la búsqueda
    const [seMuestra,setSeMuestra] = useState(true)
    //Estado que almacena el parametro de búsqueda para el muestreo de pacientes (si se encuentra vacio se consideran toda la lista de pacientes)
    const [valorBusqueda,setValorBusqueda] = useState("")

    
    

    useEffect(()=>{
        if(valorBusqueda){
            setSeMuestra(true)
        }
        else{
            setSeMuestra(false)
        }
    },[valorBusqueda])


    useEffect(()=>{
        let cantidadPacientesQuirofano = 0
        let cantidadPacientesRecuperacion = 0

        if(pacientesList.length > 0){//Verificar si existen pacientes pendites de alta
            if(valorBusqueda){//Se desea realizar búsqueda de un paciente específico
                let resultadoBusqueda = []
                pacientesList.forEach(//Se recorre la lista de pacientes
                    paciente => {
                        //Obtención del nombre de la unidad hospitalaria del paciente
                        let uhName = getUnidadHospitalariaValue(paciente.UnidadHospitalaria)

                        //Obtención del nombre del paciente
                        let patientname = paciente.patientname
                        if(!patientname){//Si el paciente no tiene registrado nombre se le asignará No Disponible
                            patientname = "No Disponible"
                        }
                        //Obtención de la fecha de nacimiento del paciente
                        let birthdate = paciente.birthdate
                        if(birthdate){//Se verifica si el paciente tiene registrada fecha de nacimiento
                            if(birthdate.toUpperCase() !== "No Disponible".toUpperCase()){//Se verifica que cuente con fecha registrada en el campo birtday
                                //Se la da formato dd-mm-yyyy a la fecha de nacimiento registrada
                                birthdate = getDateString(birthdate)
                            }
                        }
                        else{//Se le asigna No Disponible
                            birthdate = "No Disponible"
                        }

                        if(userLevel !== "superuser"){//Se verifica si el usuario no tiene privilegios de superuser
                            if(paciente.NumeroDePaciente 
                                && uhName 
                                && getUnidadHospitalariaName(descrifrar(nomHospital).toString(),uhList) === getUnidadHospitalariaName(uhName,uhList)
                                && paciente.Status !== "Salida"){//Se verifica que el paciente tenga informaicción valida y corrresponda a la unidad hospitalaria del usuario
                                //Asignar en que estado se encuentra actualmente el paciente
                                let estadoPaciente = ""
                                if(paciente.Status){//Se verifica si el paciente cuenta con estado registrado
                                    //Se asigna el estado que tiene el paciente registrado
                                    estadoPaciente = paciente.Status
                                    // if(estadoPaciente === "Especial"){
                                    //     estadoPaciente = "Complicacion"
                                    // }
                                }
                                else{//Se le asigna el estado Quirófano
                                    estadoPaciente = "Quirófano"
                                }

                                if(paciente.NumeroDePaciente.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || uhName.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || paciente.NumeroTelefono.includes(valorBusqueda)
                                    || quitarCaracteresEspeciales(birthdate.toUpperCase()).includes(quitarCaracteresEspeciales(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(patientname.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(estadoPaciente.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))){//Se realiza la búsqueda de coincidencias en los campos uhName, número de teléfono y numero de paciente
                                        if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                            if(isMostrarPacientes){
                                                resultadoBusqueda.push(paciente)
                                            }
                                        }
                                        else{
                                            if(paciente.Status === "Especial"){//Paciente en caso especial
                                                if(paciente.lastEstatus === "Quirófano"){
                                                    if(isMostrarPacientes){
                                                        resultadoBusqueda.push(paciente)
                                                    }
                                                }
                                                else{
                                                    if(!isMostrarPacientes){
                                                        resultadoBusqueda.push(paciente)
                                                    }
                                                }
                                            }
                                            else{//Paciente en recuepración
                                                if(!isMostrarPacientes){
                                                    resultadoBusqueda.push(paciente)
                                                }
                                            }
                                        }
                                        
                                }
                            }
                        }
                        else{//Usuario con privilegios superuser
                            if(paciente.NumeroDePaciente 
                                && uhName 
                                && paciente.Status !== "Salida"){//Se verifica que el paciente tenga información valida
                                //Asignar en que estado se encuentra actualmente el paciente
                                let estadoPaciente = ""
                                if(paciente.Status){//Se verifica si el paciente cuenta con estado registrado
                                    //Se asigna el estado que tiene el paciente registrado
                                    estadoPaciente = paciente.Status
                                    // if(estadoPaciente === "Especial"){
                                    //     estadoPaciente = "Complicacion"
                                    // }
                                }
                                else{//Se le asigna el estado Quirófano
                                    estadoPaciente = "Quirófano"
                                }

                                if(paciente.NumeroDePaciente.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || uhName.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || paciente.NumeroTelefono.includes(valorBusqueda)
                                    || quitarCaracteresEspeciales(birthdate.toUpperCase()).includes(quitarCaracteresEspeciales(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(patientname.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(estadoPaciente.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))){//Se realiza la búsqueda de coincidencias en los campos uhName, número de teléfono y numero de paciente
                                        if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                            if(isMostrarPacientes){
                                                resultadoBusqueda.push(paciente)
                                            }
                                        }
                                        else{
                                            if(paciente.Status === "Especial"){//Paciente en caso especial
                                                if(paciente.lastEstatus === "Quirófano"){
                                                    if(isMostrarPacientes){
                                                        resultadoBusqueda.push(paciente)
                                                    }
                                                }
                                                else{
                                                    if(!isMostrarPacientes){
                                                        resultadoBusqueda.push(paciente)
                                                    }
                                                }
                                            }
                                            else{//Paciente en recuepración
                                                if(!isMostrarPacientes){
                                                    resultadoBusqueda.push(paciente)
                                                }
                                            }
                                        }
                                    }
                            }
                        }
                    }
                )

                if(resultadoBusqueda.length > 0){//Se encontraron resultados a la búsqueda deseada
                    setHayResultados(true)
                    //Ordenar los resultados por un valor específico
                    resultadoBusqueda.sort(compararInformación('NumeroDePaciente'))
                    setCantidadPacientes(resultadoBusqueda.length)
                }
                else{//La búsqueda no obtuvo ningún paciente como resultado
                    setHayResultados(false)
                    setCantidadPacientes(0)
                }
                setPacientesAmostrarList(resultadoBusqueda)
            }
            else{//Se muestran todos los pacientes disponibles
                pacientesList.sort(compararInformación('NumeroDePaciente'))
                let pacientesValidos = 0
                pacientesList.forEach(
                    paciente => {
                        if(userLevel !== "superuser"){
                            let uhName = getUnidadHospitalariaValue(paciente.UnidadHospitalaria)
                                if(getUnidadHospitalariaName(descrifrar(nomHospital).toString(),uhList) === getUnidadHospitalariaName(uhName,uhList)
                                    && paciente.Status !== "Salida"){
                                        pacientesValidos = pacientesValidos + 1 
                                        if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                        }
                                        else{
                                            if(paciente.Status === "Especial"){//Paciente en caso especial
                                                if(paciente.lastEstatus === "Quirófano"){
                                                    cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                                }
                                                else{
                                                    cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                                }
                                            }
                                            else{//Paciente en recuepración
                                                cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                            }
                                        }
                                }
                        }
                        else{
                            if(paciente.Status !== "Salida"){
                                pacientesValidos = pacientesValidos + 1
                                if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                    cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                }
                                else{
                                    if(paciente.Status === "Especial"){//Paciente en caso especial
                                        if(paciente.lastEstatus === "Quirófano"){
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                        }
                                        else{
                                            cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                        }
                                    }
                                    else{//Paciente en recuepración
                                        cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                    }
                                }
                            }
                        }
                    }
                )

                if(pacientesValidos > 0){//Se verifica si existen pacientes que pertenezcan a la unidad hospitalaria requerida
                    if(isMostrarPacientes){
                        setCantidadPacientes(cantidadPacientesQuirofano)
                        if(cantidadPacientesQuirofano > 0){
                            setHayResultados(true)
                        }
                        else{
                            setHayResultados(false)
                        }
                    }
                    else{
                        setCantidadPacientes(cantidadPacientesRecuperacion)
                        if(cantidadPacientesRecuperacion > 0){
                            setHayResultados(true)
                        }
                        else{
                            setHayResultados(false)
                        }
                    }
                    //setCantidadPacientes(pacientesValidos)
                    setTotalQuirofano(cantidadPacientesQuirofano)
                    setTotalRecuperacion(cantidadPacientesRecuperacion)
                    setPacientesAmostrarList(pacientesList)
                    
                }
                else{//No se encientraron pacientes pertenecientes a la unidad hospitalaria
                    setPacientesAmostrarList([])
                    setHayResultados(false)
                    setCantidadPacientes(0)
                    setTotalQuirofano(0)
                    setTotalRecuperacion(0)
                }
            }
        }
        else{//No hay pacientes por mostrar
            setPacientesAmostrarList([])
            setHayResultados(false)
        }

    },[pacientesList,valorBusqueda,nomHospital,userLevel,uhList,isMostrarPacientes,setTotalQuirofano,setTotalRecuperacion])


    /**
     * Función que atrapa el evento de limpiar la búsqueda
     * @returns Devuelve el estado del objeto
     */
    const handleCancelarClick = () => (event) => {
        event.preventDefault()
        setValorBusqueda("")
    }

    return(
        <>
        <section className='seccion_pacientes_pendientes'>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                {
                    isMostrarPacientes ? <EncabezadoSeccion tituloInicial={"Pacientes pendientes de "} tituloFinal={"salida de quirófano disponibles:"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
                    : <EncabezadoSeccion tituloInicial={"Pacientes pendientes de "} tituloFinal={"salida de recuperación disponibles:"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
                }
                                    
                <div className='firstfiltercont'>
                    <div className='ftconfliter'>
                        <div className="text-container">
                            <input type="text" 
                                name="valorBusqueda" 
                                value={valorBusqueda} 
                                className='inputbuscardirectorio' 
                                placeholder="Búsqueda abierta aquí..."
                                onChange={(event) => setValorBusqueda(event.target.value)}
                            />
                            {
                                seMuestra ? <span className='clearBtn' onClick={handleCancelarClick()}>X</span>
                                : null
                            } 
                        </div>
                    </div>
                </div>
            </div>
            <div className='itemservespCont'>
                {
                    isLoader ?
                        <Loader/>
                    :
                        hayResultados ?
                            pacientesAmostrarList.map(paciente => 
                                <PacientePendienteAlta key={paciente.id} paciente={paciente} userLevel={userLevel} nomHospitalUser={nomHospital} uhList={uhList} setPacienteSeleccionado={setPacienteSeleccionado} 
                                pacienteSeleccionado={pacienteSeleccionado} pacienteIsRecuperacion={pacienteIsRecuperacion} setPacienteIsRecuperacion={setPacienteIsRecuperacion}
                                pacienteTelefonoIsVisible={pacienteTelefonoIsVisible} setPacienteTelefonoIsVisible={setPacienteTelefonoIsVisible}
                                pacienteTieneContactos={pacienteTieneContactos} setPacienteTieneContactos={setPacienteTieneContactos}
                                pacienteContactos={pacienteContactos} setPacienteContactos={setPacienteContactos}
                                name={name} pacienteUH={pacienteUH} setPacienteUH={setPacienteUH}
                                pacienteIsEspecial={pacienteIsEspecial} setPacienteIsEspecial={setPacienteIsEspecial}
                                isRecuperacionOrigen={isRecuperacionOrigen} setIsRecuperacionOrigen={setIsRecuperacionOrigen}
                                isMostrarPacientes={isMostrarPacientes}
                                pacienteUnidadHospitalariaName={pacienteUnidadHospitalariaName} setPacienteUnidadHospitalariaName={setPacienteUnidadHospitalariaName}/>
                            )
                        :
                            <SinResultados/>
                }
            </div>
        </section>
        {/* <PacienteModal paciente={pacienteSeleccionado}/> */}
        </>
        )
}

export default PacientesPendientes;